export default {
    'FD1234': {
        "id": 1,
        "customer_id": "FD1234",
        "customer_type": "RETAIL",
        "process_date": "2025-05-11",
        "process_date": "2025-05-11",
        "customer_type": "Retail",
        "business_purpose_loan_flag": "Y",
        "customers_loan_has_collateral_flag": "Y",
        "customer_id": "FD1234",
        "name": "Bùi Ngọc Lễ",
        "gender": "Female",
        "date_of_birth": "1990-02-05",
        "address": "106 HOANG QUOC VIET",
        "identification": 26090004014,
        "historical_rating_rating_date": "2010-02-05",
        "historical_rating_rating_id": "RateingID1",
        "historical_rating_rm_id": "RMCode1",
        "historical_rating_branch": "Branch001",
        "historical_rating_latest_rating": "CustomerLastest",
        "tentative_loan_product_code": "P1",
        "tentative_loan_product": "Cho vay  mua ô tô",
        "tentative_loan_amount": 1000000,
        "tentative_loan_ccy": "VND",
        "tentative_loan_tenor": "1000",
        "contract_id": "ContractID",
        "payment_frequency": "Monthly",
        "interest_rate_type": "Fixed",
        "repricing_frequency": 3,
        "original_date": "2010-02-05",
        "payment_amount_1": 1000000,
        "payment_amount_2": 1000000,
        "start_date_payment_1": "2010-03-05",
        "start_date_payment_2": "2015-03-05",
        "total_no_of_payment_1": 1000000,
        "total_no_of_payment_2": 1000000,
        "collateral_type": "C1",
        "collateral_type_name": "Bất động sản",
        "collateral_id": "ColId1",
        "collateral_currency": "VND",
        "collateral_value": 1000000,
        "collateral_value_in_local_currency": 100000,
        "collateral_senior_claim_flag": "Y",
        "collateral_eligible_cre_rre_flag": "Y",
        "eligible_other_irb_collat_flag": "Y",
        "eligible_irb_receivables_flag": "Y",
        "eligible_guarantee_flag": "Y",
        "process_date": "2015-05-11",
        "customer_id": "FD1234",
        "customer_type": "Retail",
        "business_purpose_loan_flag": "Y",
        "customers_loan_has_collateral_flag": "Y",
        "result": null,
        "time_changed": "2025-05-11T05:09:13.000Z",
        "actor": "administrator"
    },
    "CORP1234":{
        "business_purpose_loan_flag": "Y",
        "customers_loan_has_collateral_flag": "Y",
        "customer_id": "CORP1234",
        "customer_industry": "IT",
        "number_of_employees": 50,
        "revenue": 10000000000,
        "total_assets": 100000000000,
        "date_of_establishment": "2025-05-11",
        "address": "106 HOANG QUOC VIET",
        "business_license_investment_license_number": "GP232",
        "tax_code": "12345323",
        "financial_statement_date": "2025-03-01",
        "historical_rating_rating_date": "2025-05-11",
        "historical_rating_rating_id": "RateingID1",
        "historical_rating_rm_id": "RMCode1",
        "historical_rating_branch": "Branch001",
        "historical_rating_latest_rating": "CustomerLastest",
        "tentative_loan_product_code": "P6",
        "tentative_loan_amount": 1000000000,
        "tentative_loan_ccy": "VND",
        "tentative_loan_tenor": "120",
        "contract_id": "ContractID",
        "payment_frequency": "Monthly",
        "interest_rate_type": "Fixed",
        "repricing_frequency": "3",
        "original_date": "2025-05-10",
        "payment_amount_1": 100000000,
        "start_date_payment_1": "2025-05-05",
        "payment_amount_2": 100000000,
        "start_date_payment_2": "2025-05-05",
        "total_no_of_payment_1": "10",
        "total_no_of_payment_2": "13",
        "collateral_type": "C1",
        "collateral_id": "ColId1",
        "collateral_currency": "VND",
        "collateral_value": 20000000,
        "collateral_value_in_local_currency": 200000000,
        "collateral_senior_claim_flag": "Y",
        "collateral_eligible_cre_rre_flag": "Y",
        "eligible_other_irb_collat_flag": "Y",
        "eligible_irb_receivables_flag": "Y",
        "eligible_guarantee_flag": "Y",
        "collateral_type_name": "Bất động sản",
        "tentative_loan_product": "Cho vay đầu tư TSCĐ"
      }
}


// WEBPACK FOOTER //
// src/pages/Pricing/dataSample.js